// src/pages/Branch/components/BranchList.jsx
import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col, Tag, Menu, Checkbox, Dropdown,Tooltip, Drawer, Typography, Flex, Grid } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteOrRestoreBranch, fetchBranchList } from "../branchThunks";
import { App } from "antd";
import { setSelectedBranch, setIsEditBranch } from "../branchSlice";
import dayjs from "dayjs";
import { getAccessType, Trial_Limits } from "../../../../lib/functions";
import { useIsAdminUser } from "../../../../lib/accessList";
import Swal from "sweetalert2";

const { Title } = Typography;

const ALL_BRANCH_COLUMNS = [
  { key: "name", label: "Branch Name" },
  { key: "title", label: "Branch Title" },
  { key: "address", label: "Address" },
  { key: "company_type", label: "Company Type" },
  { key: "margin_rate", label: "Margin Rate" },
  { key: "branch_phone_no", label: "Phone" },
  { key: "branch_company_email", label: "Email" },
  { key: "branch_web_site", label: "Website" },
  { key: "branch_item_tax", label: "VAT %" },
  { key: "branch_trade_license_no", label: "Trade License" },
  { key: "branch_trade_license_expiry", label: "Trade Expiry" },
  { key: "branch_vat_license", label: "VAT License" },
  { key: "dha_moh_no", label: "DHA/MOH No" },
  { key: "dha_moh_expiry", label: "DHA/MOH Expiry" },
  { key: "branch_time_zone", label: "Time Zone" },
  { key: "branch_gln_no", label: "GLN No" },
  { key: "branch_gln_expiry", label: "GLN Expiry" },
  { key: "branch_po_box", label: "Po Box" },
  { key: "branch_return_policy", label: "Return Days" },
  { key: "branch_replace_policy", label: "Replace Days" },
  { key: "branch_print_type", label: "Print Type" },
  { key: "branch_is_voucher_receipt", label: "Receipt" },
  { key: "branch_is_warehouse", label: "Is Warehouse" },
  { key: "branch_is_cal_type", label: "Cal Type" },
  { key: "branch_is_serial", label: "Serial Enabled" },
  { key: "branch_is_auto_challan", label: "Auto Challan" },
  { key: "branch_is_minus_stock_sale", label: "Minus Stock Sale" },
  { key: "branch_annual_leave_type", label: "Annual Leave Type" },
  { key: "branch_annual_leave_days", label: "Annual Leave Days" },
  { key: "branch_shouldResetAccruedLeave", label: "Accrued Reset" },
  { key: "branch_leaves_carry_forward", label: "Carry Forward" },
  { key: "created_date", label: "Created" },
  { key: "status", label: "Status" },
];

const DEFAULT_VISIBLE_BRANCH_COLUMNS = [
  "name",
  "title",
  "branch_phone_no",
  "branch_company_email",
  "status",
  "created_date",
];

const BranchList = ({ branches }) => {
  let [access_type, access_type_set] = useState("");
  const [visibleKeys, setVisibleKeys] = useState(
    DEFAULT_VISIBLE_BRANCH_COLUMNS,
  );
  const [helpOpen, setHelpOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const { modal } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdminUser = useIsAdminUser();

  const authInfo = useSelector((state) => state.auth.auth_info);
  console.log(authInfo, "authInfo123");
  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;
  console.log(canEdit, canDelete, "canDelete");

  // Annual Leave and Casual Leave are the same pool, labeled by country —
  // relabel just those two entries rather than showing both.
  const isIndia = authInfo?.country === "India";
  const branchColumns = ALL_BRANCH_COLUMNS.map((col) => {
    if (col.key === "branch_annual_leave_type") {
      return { ...col, label: isIndia ? "Casual Leave Type" : "Annual Leave Type" };
    }
    if (col.key === "branch_annual_leave_days") {
      return { ...col, label: isIndia ? "Casual Leave Days" : "Annual Leave Days" };
    }
    return col;
  });


  const handleDelete = async (branch) => {
    const action = branch.status === "active" ? "disable" : "restore";
    console.log({
      id: branch.branch_id,
      action: action,
    }, branch, "brancgwwww");

    if (authInfo?.trial_mode == "yes") {
      const userName = authInfo?.userInfo?.name || "User";

      Swal.fire({
        icon: "warning",
        title: `Hi ${userName}!`,
        text: "You are currently using the Free version. Please upgrade your plan to delete existing branch.",
      });

      return;
    }

    modal.confirm({
      title: branch.status === "active" ? "Disable Branch?" : "Restore Branch?",
      content: `Branch: ${branch.name}`,
      okText: branch.status === "active" ? "Yes, Disable" : "Yes, Restore",
      cancelText: "Cancel",
      onOk: async () => {
        await dispatch(
          deleteOrRestoreBranch({
            id: branch.id,
            action: action,
          }),
        ).unwrap();
        dispatch(fetchBranchList());
      },
    });
  };

  const columns = [
    { title: "No.", render: (_, __, i) => i + 1, width: 60 },
    ...branchColumns.filter((c) => visibleKeys.includes(c.key)).map(
      ({ key, label }) => ({
        title: label,
        dataIndex: key,
        render:
          key === "branch_trade_license_expiry" ||
            key === "dha_moh_expiry" ||
            key === "branch_gln_expiry"
            ? (d) => (d ? dayjs(d).format("DD-MMM-YYYY") : "-")
            : key === "created_date"
              ? (d) => (d ? dayjs(d).format("DD-MMM-YYYY HH:mm") : "-")
              : key === "branch_is_warehouse"
                ? (v) => (v === "yes" ? "Yes" : "No")
                : key === "status"
                  ? (s) =>
                    s === "active" ? (
                      <Tag color="green">Active</Tag>
                    ) : (
                      <Tag color="red">Disabled</Tag>
                    )
                  : undefined,
      }),
    ),
    ...(access_type === "WRITE"
      ? [
        {
          title: "Actions",
          render: (_, record) => (
            <>
              <Button
                type="link"
                onClick={() => {
                  dispatch(setSelectedBranch(record));
                  dispatch(setIsEditBranch(true));
                  navigate("/settings/branch-manage/addNewBranch");
                }}
                icon={<EditOutlined />}
                disabled={!(isAdminUser || canEdit)}
              />
              <Button
                type="link"
                danger
                onClick={() => handleDelete(record)}
                icon={<DeleteOutlined />}
                disabled={!(isAdminUser || canDelete)}
              />

              {/* <Button type="link" danger onClick={() => handleDelete(record)}>
                {record.status === "active" ? "Disable" : "Restore"}
              </Button> */}
            </>
          ),
        },
      ]
      : []),
  ];

  useEffect(() => {
    const access = getAccessType("branch_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchBranchList());
  }, [dispatch]);

  const columnMenu = (
    <Menu>
      {branchColumns.map((col) => (
        <Menu.Item key={col.key}>
          <Checkbox
            checked={visibleKeys.includes(col.key)}
            onChange={(e) => {
              const checked = e.target.checked;
              setVisibleKeys((prev) =>
                checked
                  ? [...prev, col.key]
                  : prev.filter((k) => k !== col.key),
              );
            }}
          >
            {col.label}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      <Row
        justify="end"
        align="middle"
        style={{ marginBottom: "16px", marginTop: "16px" }}
      >
        <Col>
          <div style={{ display: "flex", gap: 12 }}>
            <Dropdown overlay={columnMenu} placement="bottomLeft">
              <Button>Columns</Button>
            </Dropdown>
            <Tooltip title="Help">
              <Button
                type="text"
                icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                onClick={() => setHelpOpen(true)}
              />
            </Tooltip>

            {access_type === "WRITE" && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  if (authInfo?.trial_mode == "yes" && branches.length >= Trial_Limits.branch_count) {
                    const userName = authInfo?.userInfo?.name || "User";

                    Swal.fire({
                      icon: "warning",
                      title: `Hi ${userName}!`,
                      text: "You are currently using the Free version. Please upgrade your plan to add a new branch.",
                    });

                    return;
                  }
                  dispatch(setSelectedBranch(null));
                  dispatch(setIsEditBranch(false));
                  navigate("/settings/branch-manage/addNewBranch");
                }}
              >
                Add New
              </Button>
            )}
          </div>
        </Col>
      </Row >
      <Drawer
        title="Branch Management Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={460}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "12px"
            }}
          >
            Branch Management
          </h2>

          <p style={{ color: "#555", marginBottom: "16px", marginLeft:17 }}>
            This section helps manage company branches, warehouse settings,
            branch contact details, taxation setup, operational configurations,
            and branch-level ERP workflows.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>What You Can Do</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Create and manage company branches</li>
              <li>Update branch contact and address details</li>
              <li>Configure warehouse and stock handling settings</li>
              <li>Manage TAX, GLN, and trade license information</li>
              <li>Track branch license expiry dates</li>
              <li>Configure printing and receipt settings</li>
              <li>Enable serial number and auto challan options</li>
              <li>Manage leave and HR-related branch settings</li>
              <li>Customize return and replacement policies</li>
              <li>Enable or disable branch operations</li>
              <li>Control visible table columns dynamically</li>
              <li>View branch creation history and status</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Disabled branches remain stored in the system.</li>
              <li>License expiry dates should be updated regularly.</li>
              <li>Warehouse settings affect inventory workflows.</li>
              <li>Branch tax settings affect billing and accounting.</li>
              <li>Only authorized users can edit or disable branches.</li>
              <li>Free version users have branch creation limits.</li>
              <li>Column visibility settings help simplify large branch tables.</li>
            </ul>
          </div>
        </div>
      </Drawer>

      <Table
        columns={columns}
        dataSource={branches}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        onChange={handleTableChange}
        rowKey="branch_id"
        scroll={{ x: "max-content" }} // wide scroll
      />
    </>
  );
};

export default BranchList;
